import { schema } from "normalizr";
import driverQuoteSchema from "./driverQuote";
import audienceSchema from "./audience";
import segmentSchema from "./segment";

export const driverSegmentScoreSchema = new schema.Entity(
    "driverSegmentScore",
    {
        audience: audienceSchema,
        audienceSegment: segmentSchema
    },
    {
        idAttribute: segmentScore =>
            [
                segmentScore["wevoPageId"],
                segmentScore["driverId"],
                segmentScore["audienceSegmentId"]
            ].join("_")
    }
);

const driverSchema = new schema.Entity(
    "drivers",
    {
        quotes: [driverQuoteSchema],
        segmentScores: [driverSegmentScoreSchema]
    },
    { idAttribute: "id" }
);

export default driverSchema;



// WEBPACK FOOTER //
// ./src/schemas/driver.js